import React, { useState, useEffect } from 'react'
import Layout from '../../brands/components/Layout'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '../../../redux/hook'
import { loadAllEmployeeFiles } from '../api'
import CustomPagination from '../../../components/Pagination'
import { saveEmployeeFileList } from '../slice/employeeFileSlice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../redux/slices/LoaderSlice'
import { formatDateAndTime } from '../../resources/empresources/utils'
import DelAssignment from '../components/DelEmpFileModal'
import { downloadEmpFile } from '../api'
import { normalizeLink } from '../../resources/empresources/utils'

const EmpFiles: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [deleteAssignIsShow, setDeleteAssignment] = React.useState(false)
    const [assignmentId, setAssignmentId] = React.useState<string>('')

    const { role } = useAppSelector((state) => state.persistedReducers.user)
    const { employeeFileList, totalCount } = useAppSelector(
        (state) => state.employeeFiles
    )
    const totalPages = Math.ceil(totalCount / 10)

    const column = [
        {
            key: 'title',
            name: 'Title',
            resizable: true,
            sortable: true,
            flexGrow: 150,
        },
        {
            key:
                role === 'Admin' || role === 'Executive Director'
                    ? 'userName'
                    : 'description',
            name:
                role === 'Admin' || role === 'Executive Director'
                    ? 'Employee Name'
                    : 'Description',
            resizable: true,
            sortable: true,
            width: role === 'Admin' ? 200 : 400,
            // flexGrow: 1,
            renderCell: (e: any) => (
                <div>
                    {role === 'Admin' || role === 'Executive Director'
                        ? e.row.userName
                        : e.row.description}
                </div>
            ),
        },
        {
            key: 'createdOn',
            name:
                role === 'Admin' || role === 'Executive Director'
                    ? 'Date'
                    : 'Assigned Date',
            resizable: true,
            sortable: true,
            width: 200,
        },
        {
            key: 'fileType',
            name: 'File Type',
            resizable: true,
            sortable: true,
            width: 150,
        },
        {
            key: 'actions',
            name: 'Actions', // Fix the typo here
            resizable: true,
            sortable: true,
            width: 150,
            renderCell: (e: any) => (
                <>
                    <div className="dropdown-custom-link">
                        {role === 'Admin' || role === 'Executive Director' ? (
                            <>
                                <Icon
                                    onClick={() => {
                                        navigate(
                                            `/emp/files/edit/${e.row.employeeFileId}`
                                        )
                                    }}
                                    icon="bx:edit"
                                    className="icon-primary pointer"
                                />
                                <Icon
                                    onClick={() => {
                                        setAssignmentId(e.row.employeeFileId)
                                        setDeleteAssignment(true)
                                    }}
                                    icon="icon-park-outline:delete"
                                    className="icon-secondary pointer"
                                />
                            </>
                        ) : (
                            <Icon
                                icon="ion:open-outline"
                                color="#39877C"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                    handleViewResource(
                                        e.row.employeeFileId,
                                        e.row.fileType
                                    )
                                }
                            />
                        )}
                    </div>
                </>
            ),
        },
    ]

    const handleViewResource = async (id: string, category: string) => {
        dispatch(SHOW_LOADER())
        try {
            const response = await downloadEmpFile(id)
            let resourceLink = response.data
            resourceLink = resourceLink.replace(/\\/g, '/')
            if (['Link', 'link'].includes(category)) {
                // Check if category is 'Link'
                resourceLink = normalizeLink(resourceLink)
            }
            window.open(resourceLink, '_blank')
        } catch (error) {
            console.error(error)
        } finally {
            dispatch(HIDE_LOADER())
        }
    }

    const fetchData = async () => {
        dispatch(SHOW_LOADER())
        try {
            const userlisting = await loadAllEmployeeFiles({
                currentPage: currentPage,
                recordsPerPage: 10,
                role: role,
            })
            userlisting?.data?.sort(
                (
                    a: { createdOn: string; assignedOn: string },
                    b: { createdOn: string; assignedOn: string }
                ) =>
                    new Date(
                        role === 'Admin' || role === 'Executive Director'
                            ? b.createdOn
                            : b.assignedOn
                    ).getTime() -
                    new Date(
                        role === 'Admin' || role === 'Executive Director'
                            ? a.createdOn
                            : a.assignedOn
                    ).getTime()
            )
            const data = userlisting?.data?.map((user: any) => {
                // regenerating list with formatted date
                user.createdOn = formatDateAndTime(
                    role === 'Admin' || role === 'Executive Director'
                        ? user.createdOn
                        : user.assignedOn
                )
                return user
            })

            dispatch(
                saveEmployeeFileList({
                    data: data,
                    totalCount: userlisting?.totalCount,
                    currentPage: currentPage,
                })
            )
            dispatch(HIDE_LOADER())
        } catch (err) {
            dispatch(HIDE_LOADER())
            // Handle any errors here
            console.error('Error fetching holidays:', err)
        }
    }

    useEffect(() => {
        fetchData()
    }, [currentPage])

    const getCurrentPage = (page: number) => {
        setCurrentPage(page)
    }

    return (
        <div>
            {deleteAssignIsShow && (
                <DelAssignment
                    data={{ id: assignmentId }}
                    onClose={setDeleteAssignment}
                    show={deleteAssignIsShow}
                />
            )}
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>Employee Files</h4>
                            </div>
                            {(role === 'Admin' ||
                                role === 'Executive Director') && (
                                <div className="col-sm-6">
                                    <div className="custom-btn-design">
                                        <a
                                            onClick={() => {
                                                navigate('/emp/files/upload')
                                            }}
                                            className="button button-primary button-align-right"
                                        >
                                            UPLOAD
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <>
                        {employeeFileList.length > 0 ? (
                            <DataGrid
                                className="data-grid-table"
                                columns={column}
                                rows={employeeFileList}
                                rowHeight={60}
                                headerRowHeight={40}
                                // onScroll={handleScroll}
                            />
                        ) : (
                            <div className="resources-tasks-norecords">
                                No records found
                            </div>
                        )}

                        {employeeFileList?.length > 0 && (
                            <div className="mt-2">
                                <CustomPagination
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    getPageNumber={getCurrentPage}
                                />
                            </div>
                        )}
                    </>
                </div>
            </Layout>
        </div>
    )
}

export default EmpFiles
